exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".makereservationform .control-label{text-align: left}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/html/foodbot_stage/web/src/app/wifidetails/wifidetails.component.css
// module id = ../../../../../src/app/wifidetails/wifidetails.component.css
// module chunks = main